const footerColumns = [
  {
    id: 'col-topics',
    title: '热门话题',
    links: [
      { id: 'f-live', label: '直播录屏', href: '#topics' },
      { id: 'f-raw', label: '未删减原视频', href: '#topics' },
      { id: 'f-chat', label: '聊天记录截图', href: '#topics' },
      { id: 'f-timeline', label: '时间线整理', href: '#topics' },
    ],
  },
  {
    id: 'col-types',
    title: '素材形态',
    links: [
      { id: 'f-video', label: '原视频', href: '#types' },
      { id: 'f-screen', label: '录屏', href: '#types' },
      { id: 'f-shot', label: '原始截图', href: '#types' },
      { id: 'f-source', label: '出处核查', href: '#archive' },
    ],
  },
  {
    id: 'col-help',
    title: '关于本站',
    links: [
      { id: 'f-verify', label: '核验说明', href: '#verify' },
      { id: 'f-faq', label: '常见问题', href: '#faq' },
      { id: 'f-compliance', label: '合规与免责', href: '#submit' },
      { id: 'f-submit', label: '提交线索', href: '#submit' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-16 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.4fr)_repeat(3,minmax(0,1fr))] gap-10 lg:gap-8">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-archive-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">网红黑料</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 max-w-sm">
              集中整理网红黑料实锤与相关素材的归档入口，收录原视频、录屏与原始截图，坚持有图有真相，也坚持理性看待每一条线索。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['实锤核验', '原视频留存', '录屏存档'].map((tag) => (
                <span key={tag} className="px-3 py-1.5 rounded-full bg-background-200 text-foreground-700 text-xs font-label">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.id}>
              <h4 className="font-heading text-sm font-bold text-foreground-950 tracking-wide">
                <a href={col.links[0].href} className="cursor-pointer hover:text-primary-600 transition-colors">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-secondary-900">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-200 text-center sm:text-left">
            © 2026 网红黑料 · 素材归档入口 · 本站仅作信息整理与核验展示
          </p>
          <p className="text-xs text-secondary-300 text-center sm:text-right">
            请理性浏览，以公开通报与可回溯来源为准
          </p>
        </div>
      </div>
    </footer>
  );
}